// extracted by mini-css-extract-plugin
export default {"grid":"UserGroupGridNonParticipants_grid__bQ9nu","tabContent":"UserGroupGridNonParticipants_tabContent__9Zgsg"};